module.exports = __webpack_public_path__ + "img/top.17e01ed0.svg";